import { render, staticRenderFns } from "./WeekdayBarChart.vue?vue&type=template&id=76582ba6&"
import script from "./WeekdayBarChart.vue?vue&type=script&lang=js&"
export * from "./WeekdayBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WeekdayBarChart.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76582ba6')) {
      api.createRecord('76582ba6', component.options)
    } else {
      api.reload('76582ba6', component.options)
    }
    module.hot.accept("./WeekdayBarChart.vue?vue&type=template&id=76582ba6&", function () {
      api.rerender('76582ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/WeekdayBarChart.vue"
export default component.exports